export default __webpack_public_path__ + "static/media/contact-us-1.d4eaa0ab.jpg";